import { isPresent } from 'utils/isPresent';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import Grid from "housecall-ui/dist/DesignSystem/Layout/Grid/Grid"
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import TasksHeaderPopover from './TasksHeaderPopover.jsx'
import CloseIcon from 'housecall-ui/dist/IconsAndImages/Icons/Close'

@connect(
    state => ({
        isFoundation: state.isFoundation
    }),
)
export default class TasksHeader extends PureComponent {

    render() {
        return (
        <Grid container alignItems="center" style={{height: 64}}>
            <Grid item xs={1}>
                <IconButton
                    onClick={() => {
                        parent.postMessage('requestDrawerClose', '*')
                        { isPresent(this.props.toggleTasksDrawer) ? this.props.toggleTasksDrawer() : null }
                    }}>
                    <CloseIcon/>
                </IconButton>
            </Grid>
            <Grid item xs={11}>
                <TasksHeaderPopover showMyTasks={this.props.showMyTasks}
                                    taskListToggled={this.props.taskListToggled}
                />
            </Grid>
        </Grid>
        );
    }
}
